
import Promise from "plugins/bluebird/index"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

import {
  /* eslint-disable no-unused-vars */
  InputOptions as AuthBoxInputOptions,
  /* eslint-enable no-unused-vars */
} from "concepts/authentication/box/index"


import I18n from "plugins/i18n-js"


const showSignUpModal = (
  auth_box_options: (AuthBoxInputOptions | null) = {
    enable_account_already_exists_error_message: true,
  },
) => {
  const valid_auth_box_options: AuthBoxInputOptions = auth_box_options || {
    enable_account_already_exists_error_message: true,
  }

  return Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    return q_ajax_3({
      url:      Routes.new_user_registration_path(I18n.locale),
      type:     "GET",
      dataType: "html",
    })
    .then(({data}) => {
      return Promise.resolve(
        import("app/modal/show-modal")
      )
      .then(({default: Modal}) => {
        return Modal.showModalWithContent(data, {customContent: true})
      })
    })
  })
  .then(($modal) => {
    return Promise.resolve(
      import(
        "concepts/authentication/box/index"
      )
    )
    .then(({Factory: AuthBox}) => {
      const authentication_box = AuthBox.create(
        {
          container: $modal.find(".cell-authentication-box"),
        },
        {
          enable_account_already_exists_error_message:
          valid_auth_box_options.enable_account_already_exists_error_message || true,
        },
      )

      return {
        $modal:             $modal,
        authentication_box: authentication_box,
      }
    })
  })
}

const showSignInModal = (
  auth_box_options: (AuthBoxInputOptions | null) = {
    enable_account_already_exists_error_message: true,
  },
): Promise<any> => {
  const valid_auth_box_options: AuthBoxInputOptions = auth_box_options || {
    enable_account_already_exists_error_message: true,
  }

  return Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    return q_ajax_3({
      url:      Routes.new_user_session_path(I18n.locale),
      type:     "GET",
      dataType: "html",
    })
    .then(({data}) => {
      return Promise.resolve(
        import("app/modal/show-modal")
      )
      .then(({default: Modal}) => {
        return Modal.showModalWithContent(data, {customContent: true})
      })
    })
  })
  .then(($modal) => {
    return Promise.resolve(
      import(
        "concepts/authentication/box/index"
      )
    )
    .then(({Factory: AuthBox}) => {
      const authentication_box = AuthBox.create(
        {
          container: $modal.find(".cell-authentication-box"),
        },
        {
          enable_account_already_exists_error_message:
          valid_auth_box_options.enable_account_already_exists_error_message,
        },
      )

      return {
        $modal:             $modal,
        authentication_box: authentication_box,
      }
    })
  })
}

export default {
  showSignUpModal,
  showSignInModal,
}

export {
  showSignUpModal,
  showSignInModal,
}
